import logEvent from './logEvent';
/**
 * Logs a screen_view event.
 * This is analogous to page_view, but represents an individual screen within an app.
 *
 * @param {String} areaName Name that represents the overall location/flow.
 * @param {String} screenType Name of screen analogous to page_type.
 * @param {Object} rest Additional properties to log.
 */
export default function logScreenView(areaName, screenType, rest) {
  logEvent('screen_view', {
    area_name: areaName,
    screen_type: screenType,
    ...rest,
  });
}
